module.exports = __webpack_public_path__ + "media/19 amid.b4aab5b5.mp3";